import {
  Avatar,
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import * as React from 'react';

type AvatarHeaderProps = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  icon: React.ReactNode;
} & WithStyles<typeof styles>;

const AvatarHeader: React.FunctionComponent<AvatarHeaderProps> = ({ classes, icon, subTitle, title }) => {

  return (
    <Grid
      container={true}
      direction='row'
      alignItems='center'>
      <Grid item={true} >
        <Avatar className={classes.avatar}>
          {icon}
        </Avatar>
      </Grid>
      <Grid item={true} >
        <Typography variant="h6">{title}</Typography>
        {subTitle && <Typography>{subTitle}</Typography>}
      </Grid>
    </Grid>
  );
}

const styles = (theme: Theme) => createStyles({
  avatar: {
    height: theme.spacing(5),
    marginRight: theme.spacing(2),
    width: theme.spacing(5),
  },
});

export default withStyles(styles)(AvatarHeader);
